import React from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import { Loading } from '@components/common';
import UpdateProvider from './UpdateProvider';
import { useParams } from 'react-router-dom';

const DashboardHOC = () => (Wrapper) => {
  const DashboardPage = ({
    match,
    dashboard,
    dashboardType,
    response = null,
    isFetching,
    tempIsFetching = false,
    getDashboard,
    initDashboard,
    initTempDashboard,
    fetchingAction = noop,
    ...rest
  }) => {
    const { id = '' } = useParams();

    React.useEffect(() => {
      initDashboard();
      getDashboard(id);
      return () => fetchingAction();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const responseId = `${get(response, 'id', '')}`;

    if (isFetching || (responseId && id !== responseId)) {
      return <Loading />;
    }
    return (
      <UpdateProvider
        id={id}
        dashboard={dashboard}
        dashboardType={dashboardType}
        initTempDashboard={initTempDashboard}
        response={response}
        isFetching={tempIsFetching}
      >
        {() => (tempIsFetching ? <Loading /> : <Wrapper id={id} match={match} {...rest} />)}
      </UpdateProvider>
    );
  };

  return React.memo(DashboardPage);
};

export default DashboardHOC;
